import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { IconWebComponent } from '@resident-nx/web/ui';
import {
  ImmomioIconName,
  MasterdataChangeType,
  masterDataSelectionTranslateKeys,
} from '@resident-nx/shared';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rs-web-user-profile-edit-summary',
  imports: [IconWebComponent, TranslateModule, DatePipe],
  templateUrl: './user-profile-edit-summary.component.html',
  styleUrl: './user-profile-edit-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileEditSummaryComponent {
  public now = new Date();
  changeType = input<MasterdataChangeType>();
  protected readonly ImmomioIconName = ImmomioIconName;
  protected readonly selectionTranslateKeys = masterDataSelectionTranslateKeys;
}
